import classNames from 'classnames'
import { AlertCircleOutline } from 'react-ionicons'
import { ErrorMessage } from '@hookform/error-message'
import { IonIcon } from '@/src/icons'
import { ErrorMessageWrapper } from '@/components/elements/ErrorMessageWrapper'

export interface SelectOption {
  label: string
  value: string
}

export interface SelectProps {
  id: string
  label: string
  defaultOptionLabel?: string
  className?: string
  name: string
  options: SelectOption[]
  register: any
  validationRules?: Record<string, any>
  errors?: any
  [key: string]: any
}

export const Select: React.FC<SelectProps> = ({
  label,
  defaultOptionLabel = null,
  id,
  name,
  register,
  validationRules = {},
  errors,
  options,
  className = '',
  ...rest
}) => {
  return (
    <div className={classNames('flex flex-row', className)}>
      {errors && errors[name] && (
        <IonIcon
          className="-ml-7 mr-2 w-5 h-5 text-attention"
          icon={AlertCircleOutline}
        />
      )}
      <div className="flex flex-col flex-grow">
        <label htmlFor={id} className="pb-1 font-semibold">
          {label}
        </label>
        {/* eslint-disable-next-line jsx-a11y/no-onchange */}
        <select
          {...register(name, validationRules)}
          id={id}
          className="placeholder-gray focus:focused p-2 text-navy-900 border border-gray rounded-md"
          {...rest}
        >
          {defaultOptionLabel && (
            <option disabled value="">
              {defaultOptionLabel}
            </option>
          )}
          {options.map((item) => (
            <option value={item.value} key={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        {errors && (
          <ErrorMessage errors={errors} name={name} as={ErrorMessageWrapper} />
        )}
      </div>
    </div>
  )
}
